import * as React from 'react';
import { WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { Checkbox } from 'semantic-ui-react';

import { ENDPOINTS_COMPETITIONS } from '../../../config';
import { localeData } from '../../../locales/data';
import Agreements from '../../Agreements/Agreements';
import { FieldSet } from '../../Forms';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface CompetitionFieldProps {
  handleChangeField?: (event: any, data: any) => void;
}

interface CompetitionFieldStateProps {
  errorsAgreeCompetition?: any;
  agreeCompetition: any;
  logoutCompetition: string;
  competitionName: string;
}

const CompetitionFieldMain = ({
  errorsAgreeCompetition,
  agreeCompetition,
  handleChangeField,
  logoutCompetition,
  competitionName,
  intl,
}: CompetitionFieldStateProps & InjectedIntlProps & CompetitionFieldProps) => (
  <FieldSet errors={errorsAgreeCompetition} required={true} modifiers={['agreements']}>
    <div className="accept-terms__container">
      <Checkbox
        name="agreeCompetition"
        checked={agreeCompetition === true}
        onChange={handleChangeField}
        className="form-checkbox--no-label"
        disabled={errorsAgreeCompetition && errorsAgreeCompetition.size !== 0}
      />
      <div>
        <FormattedMessageHelper
          tagName="span"
          id="step6.competition.terms"
          defaultMessage={localeData.en['step6.competition.terms']}
          values={{ competition: competitionName }}
        />

        <Agreements
          modalBtnText="step6.competition.here"
          modifiers={['competition']}
          agreementsId={logoutCompetition}
          agreementType="competition"
          banner={`${ENDPOINTS_COMPETITIONS.competitions}/${logoutCompetition}/banner`}
          shouldTriggerModalClose={true}
        />
      </div>
    </div>
  </FieldSet>
);

export default CompetitionFieldMain;
